<template>
  <div class="home flex">
    <global-mask v-if="showMask" :settings="settings" @guideEnd="setGuide" />
    <div class="app-container flex">
      <div
        v-for="(item, index) in apps"
        :key="index"
        class="app-item"
        :id="`app${index}`"
      >
        <div class="flex">
          <div class="app-icon flex-center app-name" style="color: #fff">
            <img :src="item.icon" />{{ item.name }}
          </div>
          <div class="ml-20">
            <div class="app-name">{{ item.name }}</div>
            <div
              v-if="item.stat > 0"
              class="mt-10 app-status flex-center"
              :style="`background: ${statusBg[item.stat]}`"
            >
              {{ appStatus[item.stat] }}
            </div>
            <div v-if="item.stat === 2" class="mt-10">
              至{{ item.expiryAt }}
            </div>
          </div>
        </div>
        <div class="app-desc mt-10">{{ item.desc }}</div>
        <div
          v-if="item.link"
          class="app-link flex-row mt-20"
          @click="viewVideo(item.link)"
        >
          链接：[介绍]什么是{{ item.name }}
        </div>
        <div class="app-preview mt-10 flex-column flex-row">
          <img class="preview-img" :src="item.miniCode" />
          <div class="preview-tip">{{ item.miniText || "微信扫码体验" }}</div>
        </div>
        <div
          v-if="item.stat > 0"
          class="action-btns mt-20 flex-column flex-end"
        >
          <template v-if="item.stat !== 2">
            <Button
              class="preview-btn"
              @click="toApp(item, index)"
              :loading="loading[index]"
              >深度体验</Button
            >
            <div class="mt-20 charge-btn" @click="toPurchase(item)">
              立即{{ item.stat === 3 ? "续费" : "购买" }}
            </div>
          </template>
          <template v-else>
            <Button
              class="mt-20 charge-btn"
              @click="toApp(item, index)"
              :loading="loading[index]"
              >应用管理</Button
            >
          </template>
        </div>
        <div v-if="item.stat === 3" class="bottom-tip">
          <div>您的服务已于{{ item.expiryAt }}到期。</div>
          <div>
            应用相关服务已下线，可以<span
              class="click-span"
              @click="toPurchase(item)"
              >点击此处</span
            >进行续费。我们将为您保留数据7天，至{{ item.finalAt }}。
          </div>
        </div>
      </div>
    </div>

    <div class="right" id="right">
      <div class="notice">
        <div class="flex-between">
          <div class="right-title">通知中心</div>
          <div class="right-tip" @click="toNotice">查看全部</div>
        </div>
        <div v-if="noticeList.length" class="notice-outer mt-10">
          <div v-for="(item, index) in noticeList" :key="index" class="flex">
            <div class="dot"></div>
            <div>
              <div class="date">2021/06/18 12:21:12</div>
              <div class="ellipsis-x3 notice-content">
                通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容通知内容
              </div>
              <div
                v-if="index < noticeList.length - 1"
                class="divider mt-10 mb-10"
              ></div>
            </div>
          </div>
        </div>
        <div v-else class="flex-column flex-center mt-60">
          <img src="@/assets/images/notice_empty.png" class="notice-empty" />
          <div class="empty-tip mt-20">暂无通知</div>
        </div>
      </div>
      <div class="help mt-20">
        <div class="flex-between">
          <div class="right-title">帮助中心</div>
          <div class="right-tip" @click="toHelp">前往帮助文档</div>
        </div>
        <div v-if="helpList.length" class="help-outer mt-10">
          <div
            v-for="(item, index) in helpList"
            :key="index"
            :class="`help-item${index % 2 === 0 ? ' gray-item' : ''}`"
            @click="toHelp(item.activeName)"
          >
            {{ item.title }}
          </div>
        </div>
        <div v-else class="flex-column flex-center mt-60">
          <img src="@/assets/images/notice_empty.png" class="notice-empty" />
          <div class="empty-tip mt-20">暂无文档</div>
        </div>
      </div>
    </div>

    <Modal v-model="videoModal" width="800" footer-hide>
      <video :src="videoUrl" controls style="width: 720px" />
    </Modal>
  </div>
</template>

<script>
import { apps, appStatus, statusBg, appPath, statusObj } from "./config";
import { menuList } from "../help/config";
import GlobalMask from "_c/Mask/mask";
import { appApi } from "@/api";
import dayjs from "dayjs";
export default {
  name: "Home",

  components: { GlobalMask },

  data() {
    return {
      apps,
      appStatus,
      statusBg,
      appPath,
      statusObj,
      menuList,
      settings: [
        {
          top: "-10px",
          position: "right",
          guides: [
            "欢迎来到趣增长应用平台",
            "在左边可以管理所有应用，",
            "超级强大的运营工具等你来体验！",
          ],
          guideStyle: "width: 330px; top: 180px",
        },
        {
          top: "-10px",
          position: "left",
          guides: [
            "这里是通知中心，应用的通知都",
            "会在这里显示，要注意查看哦！",
          ],
          guideStyle: "width: 325px; top: 45px",
        },
        {
          top: "330px",
          position: "left",
          guides: [
            "这里是帮助中心和客服入口，如果有",
            "问题的话可以在这里寻找答案哦",
          ],
          guideStyle: "width: 360px; top: 45px",
        },
      ],
      showMask: false,
      noticeList: [],
      helpList: [],
      videoModal: false,
      videoUrl: "",
      loading: [],
    };
  },

  created() {
    let list = [];
    this.menuList.forEach((item, index) => {
      item.subList.forEach((it, idx) => {
        list.push({
          ...it,
          activeName: `${index}-${idx}`,
        });
      });
    });
    this.helpList = list;
  },

  mounted() {
    this.getAppList();
    this.checkGuide();
  },

  methods: {
    getAppList() {
      appApi.getAppList().then((res) => {
        if (res.code === 0) {
          let data = res.result;
          let apps = this.apps;
          apps = apps.map((item) => {
            if (data[item.appType]) {
              let obj = data[item.appType].mchMap;
              let mchInfo = obj[2] || obj[1];
              item.stat = this.statusObj[mchInfo.status];
              item.mchType = mchInfo.mchType;
              item.expiryAt = mchInfo.expiryAt || "";
              item.mchId = mchInfo.mchId;
              if (item.stat === 3) {
                item.finalAt = dayjs(
                  dayjs(item.expiryAt).add(7, "day").$d
                ).format("YYYY-MM-DD HH:mm:ss");
                item.mchType = 1;
                item.mchId = obj[1].mchId;
              }
            }
            return item;
          });
          this.apps = apps;
          this.loading = JSON.parse(
            JSON.stringify(Array(apps.length).fill(false))
          );
        }
      });
    },

    checkGuide() {
      appApi.checkGuideStatus().then((res) => {
        if (res.code === 0 && !res.result) {
          setTimeout(() => {
            this.$nextTick(() => {
              this.calcSize();
            });
          }, 10);
        }
      });
    },

    setGuide() {
      appApi.setGuideStatus();
    },

    calcSize() {
      let settings = this.settings;
      // 左侧app模块
      let appW = document.getElementById("app0").clientWidth * 3 + 60;
      let appLeft = document.getElementById("app0").offsetLeft - 10;
      settings[0].left = `${appLeft}px`;
      settings[0].w = `${appW}px`;
      settings[0].h = `${document.getElementById("app0").clientHeight + 20}px`;
      // 右侧
      let rightW = document.getElementById("right").clientWidth + 20;
      settings[1].left = `${appLeft + appW}px`;
      settings[1].w = `${rightW}px`;
      settings[1].h = "340px";
      settings[2].left = `${appLeft + appW}px`;
      settings[2].w = `${rightW}px`;
      settings[2].h = "340px";
      this.$set(this, "settings", settings);
      this.showMask = true;
    },

    toNotice() {
      if (!this.noticeList.length) {
        this.$Notice.warning({
          title: "暂无通知哦",
        });
        return;
      }
      this.$router.push({
        path: "/notice",
      });
    },

    toPurchase(item) {
      const newUrl = this.$router.resolve({
        name: "purchase",
        query: { type: item.appType },
      });
      window.open(newUrl.href, "_blank");
    },

    toApp(item, index) {
      this.$set(this.loading, index, true);
      let { appType, mchType = 1, mchId = "" } = item;
      let p = {
        appType,
        mchType,
      };
      appApi.getAppToken(p).then((res) => {
        this.$set(this.loading, index, false);
        if (res.code === 0) {
          let token = res.result;
          this.$stateActions.setGlobalState({ token, mchType, mchId });
          this.$router.push({
            path: `/sub-app/${this.appPath[appType]}`,
          });
        } else {
          this.$Message.error(res.errorMsg);
        }
      });
    },

    toHelp(activeName) {
      console.log(activeName);
      if (!this.helpList.length) {
        this.$Notice.warning({
          title: "暂无文档哦",
        });
        return;
      }
      let query = {};
      if (activeName && typeof activeName === "string")
        query.activeName = activeName;
      const newUrl = this.$router.resolve({ name: "help", query });
      window.open(newUrl.href, "_blank");
    },

    viewVideo(url) {
      this.videoModal = true;
      this.videoUrl = url;
    },
  },
};
</script>

<style lang="less" scoped>
.home {
  position: relative;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: scroll;
  // zoom: .6;

  .app-container {
    min-width: 1080px;
    max-width: 1080px;
    flex-wrap: wrap;
    max-height: 100vh;
    overflow: scroll;
  }

  .app-item {
    box-sizing: border-box;
    position: relative;
    min-width: 340px;
    max-width: 340px;
    min-height: 680px;
    background: #ffffff;
    box-shadow: 1px 0px 4px 0px #e3d0ff;
    border-radius: 7px;
    padding: 30px 20px;
    margin-right: 20px;
    margin-bottom: 20px;
    &:hover {
      box-shadow: 4px 0px 8px 0px #e3d0ff;
    }
  }

  .app-icon {
    position: relative;
    width: 100px;
    height: 100px;
    z-index: 10;

    img {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
      border-radius: 10px;
    }
  }

  .app-name {
    font-size: 22px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
  }

  .app-status {
    width: 46px;
    height: 20px;
    background: #feb800;
    color: #fff;
    border-radius: 4px;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 17px;
  }

  .app-desc {
    height: 96px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 28px;
  }

  .app-link {
    width: 100%;
    background: #f7f9fa;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 25px;
    padding: 20px 12px;
    cursor: pointer;
  }

  .app-preview {
    width: 100%;
  }

  .preview-img {
    height: 150px;
  }

  .preview-tip {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 25px;
  }

  .action-btns {
    width: 100%;
    height: 130px;
  }

  .preview-btn,
  .charge-btn {
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 7px;
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    line-height: 28px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }

  .preview-btn {
    border: 1px solid #613ea4;
    color: #613ea4;
  }

  .charge-btn {
    background: linear-gradient(153deg, #975eec 0%, #623ea5 100%);
    color: #fff;
  }

  .bottom-tip {
    position: absolute;
    min-width: 100%;
    max-width: 100%;
    left: 0;
    bottom: 0;
    background: #f7f9fa;
    border-radius: 0px 0px 7px 7px;
    padding: 10px 15px;
    width: 417px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
  }

  .click-span {
    text-decoration: underline;
    font-weight: 600;
    cursor: pointer;
  }

  .right {
    min-width: 300px;
    max-width: 300px;
    min-height: 100%;

    .notice,
    .help {
      position: relative;
      width: 100%;
      height: 320px;
      background: #fff;
      box-shadow: 1px 0px 4px 0px #e3d0ff;
      border-radius: 7px;
      padding: 20px;
      &:hover {
        box-shadow: 4px 0px 8px 0px #e3d0ff;
      }
    }

    .help {
      // height: 360px;
    }

    .right-title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #333333;
      line-height: 30px;
      &::before {
        content: "|";
        color: #613ea4;
        margin-right: 10px;
      }
    }

    .right-tip {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 30px;
      text-decoration: underline;
      cursor: pointer;
    }

    .notice-empty {
      width: 200px;
    }

    .notice-outer,
    .help-outer {
      height: ~"calc(100% - 40px)";
      overflow: scroll;
    }

    .dot {
      width: 5px;
      min-width: 5px;
      height: 5px;
      background: #613ea4;
      border-radius: 50%;
      margin-top: 7px;
      margin-right: 10px;
    }

    .date {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 20px;
    }

    .notice-content {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 28px;
    }

    .divider {
      width: 100%;
      height: 1px;
      background: #c5c5c5;
    }

    .help-item {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0 12px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 25px;
      cursor: pointer;
    }

    .gray-item {
      background: #f7f9fa;
    }
  }
}

@media screen and (min-width: 1420px) {
  .home {
    justify-content: center;
  }
}

@media screen and (min-width: 1700px) {
  .home {
    .app-container {
      min-width: 1260px;
      max-width: 1260px;
    }
    .app-item {
      min-width: 400px;
      max-width: 400px;
    }

    .right {
      min-width: 400px;
      max-width: 400px;
    }
  }
}
</style>
